import React from 'react';

const PrivacyPage = () => {
  return (
    <div style={{ maxWidth: '95%', margin: '0 auto', padding: '5%', textAlign: 'center' }}>
      <div style={{ textAlign: 'center', fontSize: '200%' }}>
        <strong><b>Tipserve Privacy Policy</b></strong>
      </div>

      <div style={{ textAlign: 'center' }}>
        <p><strong>Effective Date:</strong> 20th September 2024</p>
      </div>
      <br />
      <br />

      <div className="intro">
        <p>At <strong>Tipserve</strong>, we take your privacy seriously and are committed to protecting the personal information you provide. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our mobile application.</p>
      </div>

      <br/>
      <div style={{ textAlign: 'center' }}>
        <strong>1. Information We Collect</strong>
      </div>
      
        <p>We do not collect any personal information directly from your device unless explicitly stated. Our app requires the following permissions:</p>
        <ul>
          <li><strong>Notification Permission:</strong> We may send you notifications to keep you informed about important updates, features, or reminders related to the app’s functionality. You can opt-out of these notifications at any time through your device settings.</li>
          <li><strong>Internet Permission:</strong> The app requires internet access to function properly and deliver content, features, and updates. We do not collect, store, or track any personal information during internet usage.</li>
        </ul>

        <br />
        <div style={{ textAlign: 'center' }}>
        <strong>2. How We Use the Permissions</strong>
      </div>
        <p><strong>Notifications:</strong> We use push notifications to send important messages or updates directly to your device. You have the option to disable these notifications in your device settings if you choose.</p>
        <p><strong>Internet Access:</strong> Internet access is used solely to provide real-time updates, content, and functionality related to the app’s features. No personal data is transmitted or stored as part of this process.</p>

        <br />
        <div style={{ textAlign: 'center' }}>
        <strong>3. Third-Party Services</strong>
        </div>
        <p>We do not share your information with third parties. Our app does not use third-party analytics tools, advertising services, or data tracking mechanisms.</p>

        <br />
        <div style={{ textAlign: 'center' }}>
        <strong>4. Data Security</strong>
        </div>
        <p>We are committed to protecting the security of your data. Even though we do not collect any personal data, we use industry-standard security measures to safeguard any information transmitted through the app’s internet connection.</p>

        <br />
        <div style={{ textAlign: 'center' }}>
        <strong>5. User Control</strong>
        </div>
        <p>You have full control over the notifications you receive and can disable or adjust them in your device settings.</p>
        <p>You can use the app without providing personal data, as the app does not collect, store, or process personal information.</p>


        <br />
        <div style={{ textAlign: 'center' }}>
        <strong>6. Changes to This Privacy Policy</strong>
        </div>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted within the app and on our website, and the effective date will be updated accordingly. Please review this policy periodically to stay informed about how we are protecting your privacy.</p>


        <br />
        <div style={{ textAlign: 'center' }}>
        <strong>7. Contact Us</strong>
        </div>
        <p>If you have any questions or concerns about this Privacy Policy or the app’s privacy practices, please contact us at:</p>
        <p><strong>hello@tipsource.io</strong></p>
    </div>
  );
};

export default PrivacyPage;
